var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown-select',{attrs:{"name":"color","value":_vm.selected.id,"list":_vm.selectorItems,"disabled":_vm.disabled},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }